export class EqType {
  constructor(originalValue, conversionValue) {
    this.originalValue = originalValue
    this.conversionValue = conversionValue
  }
}

export const CODE_NAME = 'EQSize'

export const CONVERSION_HC = new EqType('HC', 'HQ')

export const CONVERSION_LIST = [CONVERSION_HC]

/**
 *  return null:没找到.
 */
export function getConversionValue(code) {
  if (!code) {
    return ''
  }
  let data = null
  for (const obj of CONVERSION_LIST) {
    if (obj.originalValue === code) {
      data = obj
      break
    }
  }
  if (data) {
    return data.conversionValue
  } else {
    return code
  }
}
